import { createLocalStorageProvider } from '@jira/platform__browser-storage-providers/src/controllers/local-storage/index.tsx';

const storage = createLocalStorageProvider('jsm-insight-reports-assets-deeplinking-modal');

/** Persisted flag: `false` after the user dismisses the onboarding modal; absent means show once. */
const MODAL_OPEN_STORAGE_KEY = 'modalOpen';

/** Initial visibility: `false` in local storage means the user already dismissed the onboarding modal. */
export const readAssetsDeeplinkingModalShouldShow = (): boolean => {
	const stored = storage.get(MODAL_OPEN_STORAGE_KEY);
	return stored !== false;
};

export const persistAssetsDeeplinkingModalClosed = (): void => {
	// @browser-storage setter
	storage.setStrictlyNecessaryItem(MODAL_OPEN_STORAGE_KEY, false);
};
